const cfmHash = (value) => {
  let hash = 2166136261;
  for (let index = 0; index < value.length; index += 1) {
    hash ^= value.charCodeAt(index);
    hash = Math.imul(hash, 16777619);
  }
  return hash >>> 0;
};

const cfmShuffle = (items, seed) => {
  const output = [...items];
  let state = seed || 1;
  for (let index = output.length - 1; index > 0; index -= 1) {
    state = (state * 1664525 + 1013904223) >>> 0;
    const swapIndex = state % (index + 1);
    [output[index], output[swapIndex]] = [output[swapIndex], output[index]];
  }
  return output;
};

const getCohort = () => {
  const key = 'cfm_merch_cohort';
  let cohort;
  try {
    cohort = localStorage.getItem(key);
    if (!cohort) {
      cohort = globalThis.crypto?.randomUUID?.() || `${Date.now()}-${Math.random()}`;
      localStorage.setItem(key, cohort);
    }
  } catch {
    cohort = `${new Date().toISOString().slice(0, 10)}-${navigator.userAgent}`;
  }
  return cohort;
};

const track = (eventName, parameters) => {
  if (typeof window.gtag === 'function') {
    window.gtag('event', eventName, parameters);
    return;
  }
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: eventName, ...parameters });
};

const rotateMerchandise = () => {
  document.querySelectorAll('[data-cfm-merch-grid]').forEach((grid) => {
    const cards = [...grid.querySelectorAll('[data-cfm-merch-card]')];
    if (!cards.length) return;
    const day = new Date().toISOString().slice(0, 10);
    const cohort = getCohort();
    const ordered = cfmShuffle(cards, cfmHash(`${day}:${cohort}`));
    const limit = Number(grid.dataset.cfmMerchLimit || 8);
    ordered.forEach((card, index) => {
      grid.append(card);
      card.dataset.cfmVisible = String(index < limit);
      card.dataset.cfmMerchSlot = String(index + 1);
      if (index < limit) {
        const link = card.querySelector('a[href]');
        if (link) {
          const url = new URL(link.href, window.location.origin);
          url.searchParams.set('cfm_slot', String(index + 1));
          url.searchParams.set('cfm_cohort', String(cfmHash(cohort) % 100));
          link.href = `${url.pathname}${url.search}`;
        }
      }
    });
    track('cfm_merch_impression', {
      cfm_cohort: String(cfmHash(cohort) % 100),
      item_list_name: grid.dataset.cfmMerchList || 'featured_edit',
      items: ordered.slice(0, limit).map((card, index) => ({
        item_id: card.dataset.productId,
        item_name: card.dataset.productTitle,
        index: index + 1,
      })),
    });
  });
};

const registerMerchandiseClicks = () => {
  document.addEventListener('click', (event) => {
    const card = event.target.closest('[data-cfm-merch-card]');
    if (!card) return;
    track('cfm_merch_click', {
      item_id: card.dataset.productId,
      item_name: card.dataset.productTitle,
      index: Number(card.dataset.cfmMerchSlot || 0),
      item_list_name: card.closest('[data-cfm-merch-grid]')?.dataset.cfmMerchList || 'featured_edit',
    });
  });
};

const revealSections = () => {
  const items = [...document.querySelectorAll('[data-cfm-reveal]')];
  if (!items.length || !('IntersectionObserver' in window)) {
    items.forEach((item) => item.classList.add('is-visible'));
    return;
  }
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
  items.forEach((item) => observer.observe(item));
};

document.addEventListener('DOMContentLoaded', () => {
  rotateMerchandise();
  registerMerchandiseClicks();
  revealSections();
});
